// import { medialUrl } from "../../../EndPoints";
import { ApartmentIcon } from "../../Woven/components/WovenMedias";

import LadiesLongSleeveImage from "../../../assets/images/products/knit/ladies-long-sleeve.png";
import LadiesTankTopImage from "../../../assets/images/products/knit/ladies-tank-top.png";
import LadiesTShirtImage from "../../../assets/images/products/knit/ladies-ss-tshirt.png";
import LadiesFrockImage from "../../../assets/images/products/knit/ladies-frock.png";
import PoloTShirtImage from "../../../assets/images/products/knit/polo-shirt.png";
import NightDressImage from "../../../assets/images/products/knit/night-dress.png";
import KidsItemImage from "../../../assets/images/products/knit/kids-item.png";
import YogaImage from "../../../assets/images/products/knit/yoga.png";

// const LadiesLongSleeveImage = `${medialUrl}/img/Knit/Knit_1.png`;
// const LadiesTankTopImage = `${medialUrl}/img/Knit/Knit_2.png`;
// const LadiesTShirtImage = `${medialUrl}/img/Knit/Knit_3.png`;
// const LadiesFrockImage = `${medialUrl}/img/Knit/Knit_4.png`;
// const PoloTShirtImage = `${medialUrl}/img/Knit/Knit_5.png`;
// const NightDressImage = `${medialUrl}/img/Knit/Knit_6.png`;
// const KidsItemImage = `${medialUrl}/img/Knit/Knit_7.png`;
// const YogaImage = `${medialUrl}/img/Knit/Knit_8.png`;

export const knitArray = [
  {
    img: LadiesLongSleeveImage,
    text: "Ladies Long Sleeve T-Shirt",
  },
  {
    img: LadiesTankTopImage,
    text: "Ladies Tank Top",
  },
  {
    img: LadiesTShirtImage,
    text: "Ladies S/S T-Shirt",
  },
  {
    img: LadiesFrockImage,
    text: "Ladies Frock",
  },
  {
    img: PoloTShirtImage,
    text: "Polo Shirt",
  },
  {
    img: NightDressImage,
    text: "Night Dress",
  },
  {
    img: KidsItemImage,
    text: "Kids’ Item",
  },
  {
    img: YogaImage,
    text: "Yoga",
  },
];

export const knitStatCounter = [
  {
    number: 30,
    text: "Lines",
    icon: ApartmentIcon,
  },
  {
    number: "0.0",
    sign: "%",
    text: "Re-work & Re-check",
    icon: ApartmentIcon,
  },
];
